import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';

import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';

import {
  ProfileOutlined,
} from '@ant-design/icons';
import {
  Button, Popconfirm, Popover, Radio,
} from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
/**
 *
 */
class PurchaseFooter extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      rejectionAction: 'PREVIOUS_APPROVER',
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param {*} stepKeyArray
   * @param {*} btnStatus
   */
  handlePurchaseOrder(stepKeyArray, btnStatus) {
    const {
      updatePoWorkflowStep, user, callback,
    } = this.props;
    const { rejectionReason, rejectionAction } = this.state;
    const payload = [];
    stepKeyArray.map((item, index) => {
      const currentWorkFlowSteps = stepKeyArray[index]?.workflow_steps;
      const allValidKeys = Object.keys(currentWorkFlowSteps)?.filter((itemOne) => currentWorkFlowSteps[itemOne]);
      allValidKeys.map((itemKey, indexOne) => {
        if ((currentWorkFlowSteps[itemKey]?.status === 'PENDING') && (currentWorkFlowSteps[allValidKeys[indexOne - 1]]?.status === 'APPROVED' || indexOne === 0) && (user?.user_roles?.includes(stepKeyArray[index]?.workflow_steps?.[itemKey]?.role_id))) {
          const currentItemKey = itemKey?.split('_')?.[1];
          const tempObj = {
            step_number: Number(currentItemKey),
            step_status: btnStatus,
            po_id: item?.po_id,
            rejection_reason: rejectionReason,
            action: rejectionAction,
          };
          payload.push(tempObj);
        }
      });
    });
    updatePoWorkflowStep(payload, () => {
      callback();
    });
  }

  /**
   *
   * @param {*} stepKeyArray
   * @param {*} btnStatus
   */
  handlePaymentApproval(stepKeyArray, btnStatus) {
    const {
      updatePaymentOutgoingWorkflow, user, getPaymentsOutgoing, callback,
    } = this.props;
    const { rejectionReason, rejectionAction } = this.state;
    const payload = [];
    // eslint-disable-next-line array-callback-return
    stepKeyArray.map((item, index) => {
      const currentWorkFlowSteps = stepKeyArray[index]?.workflow_steps;
      const allValidKeys = Object.keys(currentWorkFlowSteps)?.filter((itemOne) => currentWorkFlowSteps[itemOne]);
      // eslint-disable-next-line array-callback-return
      allValidKeys.map((itemKey, indexOne) => {
        if ((currentWorkFlowSteps[itemKey]?.status === 'PENDING') && (currentWorkFlowSteps[allValidKeys[indexOne - 1]]?.status === 'APPROVED' || indexOne === 0) && (user?.user_roles?.includes(stepKeyArray[index]?.workflow_steps?.[itemKey]?.role_id))) {
          const currentItemKey = itemKey?.split('_')?.[1];
          const tempObj = {
            step_number: Number(currentItemKey),
            step_status: btnStatus,
            payment_id: item?.payment_id,
            rejection_reason: rejectionReason,
            action: rejectionAction,
          };
          payload.push(tempObj);
        }
      });
    });
    updatePaymentOutgoingWorkflow(payload, () => {
      getPaymentsOutgoing('', 5, user?.tenant_info?.tenant_id, '', 'PENDING', '', 'ISSUED');
      callback();
    });
  }

  /**
   *
   * @return
   */
  render() {
    const {
      selectedRows, isApprovalPayments, updatePaymentOutgoingWorkflowLoading, updatePoWorkflowStepLoading, getPurchaseOrdersV2Loading,
    } = this.props;
    const {
      showRejectionPopover, rejectionReason, formSubmitted, rejectionAction,
    } = this.state;

    return (
      <Fragment>
        { selectedRows?.length ? (
          <div className="fixed-footer__container">
            <div className="fixed-footer__left">
              <div className="fixed-footer__icon">
                <ProfileOutlined />

              </div>
              {selectedRows?.length || 0}
              {' '}
              Selected
            </div>
            <div className="fixed-footer__right">
              {
                isApprovalPayments ? (
                  <Fragment>

                    <Button
                      onClick={() => (this.setState({ showRejectionPopover: true }))}
                      type="danger"
                      style={{ marginRight: '5px' }}
                      disabled={updatePaymentOutgoingWorkflowLoading}
                      loading={updatePaymentOutgoingWorkflowLoading}
                    >

                      {selectedRows?.length && selectedRows?.length === 1 ? 'Reject' : 'Reject All'}

                    </Button>

                    <Popover
                      placement="topLeft"
                      title="Are you sure you want to reject?"
                      open={showRejectionPopover}
                      content={(
                        <div className="reject-box__wrapper">
                          <H3FormInput
                            value={rejectionReason}
                            onChange={(event) => this.setState({ rejectionReason: event.target.value })}
                            name="rejection reason"
                            type="text"
                            containerClassName="orgInputContainer"
                            labelClassName="orgFormLabel"
                            inputClassName="orgFormInput"
                            placeholder=""
                            disabled={updatePaymentOutgoingWorkflowLoading}
                            label="Rejection Reason"
                            maxlength="100"
                            required
                            showError={formSubmitted && !rejectionReason}
                          />
                          <div className="orgInputContainer">
                            <H3Text text="Request for changes?" className="orgFormLabel" />
                            <Radio.Group
                              onChange={(event) => this.setState({ rejectionAction: event.target.value })}
                              value={rejectionAction}
                            >
                              <Radio value="PREVIOUS_APPROVER">Yes, Send to Previous Approver</Radio>
                              <br />
                              <Radio value="INITIATOR">Yes, Send to Initiator</Radio>
                              <br />
                              <Radio value="REJECT_COMPLETELY">No, Reject Completely</Radio>
                            </Radio.Group>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <Button
                              onClick={() => {
                                this.setState({ formSubmitted: true });
                                if (!updatePaymentOutgoingWorkflowLoading && rejectionReason) {
                                  this.handlePaymentApproval(selectedRows, 'REJECTED');
                                }
                              }}
                              size="small"
                              type="primary"
                              loading={updatePaymentOutgoingWorkflowLoading}
                            >
                              Reject
                            </Button>
                            <Button
                              onClick={() => this.setState({ showRejectionPopover: false })}
                              size="small"
                              type="default"
                              disabled={updatePaymentOutgoingWorkflowLoading}
                              style={{ marginLeft: '5px' }}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      )}
                      trigger="click"
                    />
                    <Popconfirm title="Are you sure to Reject Approve Payments ?" onConfirm={() => (this.handlePaymentApproval(selectedRows, 'APPROVED'))}>
                      <Button
                        type="primary"
                        disabled={updatePaymentOutgoingWorkflowLoading}
                        loading={updatePaymentOutgoingWorkflowLoading}
                      >
                        {selectedRows?.length && selectedRows?.length === 1 ? 'Approve' : 'Approve All'}
                      </Button>
                    </Popconfirm>
                  </Fragment>
                ) : (
                  <Fragment>

                    <Button
                      onClick={() => (this.setState({ showRejectionPopover: true }))}
                      type="danger"
                      style={{ marginRight: '5px' }}
                      disabled={updatePoWorkflowStepLoading}
                    >
                      {selectedRows?.length && selectedRows?.length === 1 ? 'Reject' : 'Reject All'}
                    </Button>

                    <Popover
                      placement="topLeft"
                      title="Are you sure you want to reject?"
                      open={showRejectionPopover}
                      content={(
                        <div className="reject-box__wrapper">
                          <H3FormInput
                            value={rejectionReason}
                            onChange={(event) => this.setState({ rejectionReason: event.target.value })}
                            name="rejection reason"
                            type="text"
                            containerClassName="orgInputContainer"
                            labelClassName="orgFormLabel"
                            inputClassName="orgFormInput"
                            placeholder=""
                            disabled={updatePoWorkflowStepLoading}
                            label="Rejection Reason"
                            maxlength="100"
                            required
                            showError={formSubmitted && !rejectionReason}
                          />
                          <div className="orgInputContainer">
                            <H3Text text="Request for changes?" className="orgFormLabel" />
                            <Radio.Group
                              onChange={(event) => this.setState({ rejectionAction: event.target.value })}
                              value={rejectionAction}
                            >
                              <Radio value="PREVIOUS_APPROVER">Yes, Send to Previous Approver</Radio>
                              <br />
                              <Radio value="INITIATOR">Yes, Send to Initiator</Radio>
                              <br />
                              <Radio value="REJECT_COMPLETELY">No, Reject Completely</Radio>
                            </Radio.Group>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <Button
                              onClick={() => {
                                this.setState({ formSubmitted: true });
                                if (!updatePoWorkflowStepLoading && rejectionReason) {
                                  this.handlePurchaseOrder(selectedRows, 'REJECTED');
                                }
                              }}
                              size="small"
                              type="primary"
                              loading={updatePoWorkflowStepLoading}
                            >
                              Reject
                            </Button>
                            <Button
                              onClick={() => this.setState({ showRejectionPopover: false })}
                              size="small"
                              type="default"
                              disabled={updatePoWorkflowStepLoading}
                              style={{ marginLeft: '5px' }}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      )}
                      trigger="click"
                    />
                    <Popconfirm title="Are you sure to Approve selected purchase orders?" onConfirm={() => (this.handlePurchaseOrder(selectedRows, 'APPROVED'))}>
                      <Button
                        type="primary"
                        disabled={updatePoWorkflowStepLoading || getPurchaseOrdersV2Loading}
                      >
                        {selectedRows?.length && selectedRows?.length === 1 ? 'Approve' : 'Approve All'}
                      </Button>
                    </Popconfirm>
                  </Fragment>

                )
              }

            </div>
          </div>
        ) : null}

      </Fragment>

    );
  }
}
const mapStateToProps = ({ UserReducers, PaymentOutgoingReducers, PurchaseOrderReducers, GetPurchaseOrders }) => ({
  user: UserReducers.user,
  updatePaymentOutgoingWorkflowLoading: PaymentOutgoingReducers.updatePaymentOutgoingWorkflowLoading,
  updatePoWorkflowStepLoading: PurchaseOrderReducers.updatePoWorkflowStepLoading,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,


});

const mapDispatchToProps = (dispatch) => ({
  updatePoWorkflowStep: (payload, callback) => dispatch(PurchaseOrderActions.updatePoWorkflowStep(payload, callback)),
  updatePaymentOutgoingWorkflow: (payload, callback) => dispatch(PaymentOutgoingActions.updatePaymentOutgoingWorkflow(payload, callback)),
  getPaymentsOutgoing: (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvedStatus) => dispatch(PaymentOutgoingActions.getPaymentsOutgoing(page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvedStatus)),
});

PurchaseFooter.propTypes = {
  updatePoWorkflowStep: PropTypes.func,
  updatePaymentOutgoingWorkflowLoading: PropTypes.bool,
  updatePoWorkflowStepLoading: PropTypes.bool,
  updatePaymentOutgoingWorkflow: PropTypes.func,
  user: PropTypes.any,
  getPaymentsOutgoing: PropTypes.any,
  isApprovalPayments: PropTypes.bool,
  callback: PropTypes.func,
  selectedRows: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseFooter));
